import React, { useRef } from 'react';
import styled from "styled-components";
import PropTypes from "prop-types";
import {ESCAPE} from '../constants/keys'

import ClearIcon from '../icons/ClearIcon';
import { connect } from 'react-redux';

const StyledModal = styled.div`
    border-radius: 4px;
    box-shadow: -2px 2px 10px 0 rgba(102, 116, 166, 0.2);
    padding: 20px 25px 25px;
    background-color: #fff;
    color: #444;
    
    height: fit-content;
    margin: auto auto;
`

const StyledBackdrop = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999999;
    background-color: rgba(255, 255, 255, 0.80);
    display: flex;
    align-items: center;
    justify-content: center;

    overflow: auto;
    padding: 20px 20px;
`


const SyledHeader = styled.div`
    display: flex;
    margin: 0 0 15px;
    align-items: center;
`

const Title = styled.div`
    margin: 0 15px 0 0;
    text-transform: uppercase;
    font-size: 1.25em;
    font-weight: ${props => props.fontWeight}
`

const CloseButton = styled.button`
    padding: 5px;
    margin: 0 0 0 auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;
`

const Body = styled.div`

`;


const RitModal = (props) => {
    const {
        title,
        onClose,
        children,
        isOpened,
        closeOnEsc,
        titledWeight,
    } = props;

    if (!isOpened) {
        return null;
    }

    const handleClose = (e) => {
        onClose();
    }

    React.useEffect(() => {
        const onKeyDownClose = event => {
            if (event.keyCode === ESCAPE) handleClose()
        }

        if (closeOnEsc) {
            window.addEventListener('keydown', onKeyDownClose)
        }
        return function cleanup() {
            if (closeOnEsc) {
                window.removeEventListener('keydown', onKeyDownClose)
            }
        };
      });

    return (
        <StyledBackdrop>
            <StyledModal>
                <SyledHeader>
                    <Title fontWeight={titledWeight}>
                        {title}
                    </Title>
                    <CloseButton
                        onClick={handleClose}
                    >
                        <ClearIcon style={{ width: '1em', height: '1em' }} />
                    </CloseButton>
                </SyledHeader>
                <Body>
                    {children}
                </Body>
            </StyledModal>
        </StyledBackdrop>
    )
}

RitModal.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpened: PropTypes.bool,
    closeOnEsc: PropTypes.bool.isRequired,
    titledWeight: PropTypes.oneOf(['lighter', 'normal', 'bold'])
};


export default connect(
    null, null,
)(RitModal);

